const ACTIONS = {
  LOGIN: "login",
  REGISTER: "register",
  LOGOUT: "logout",
  SET_USER: "set-user",
};

export default ACTIONS;
